<template>
  <div class="gateway park-service">
    <!-- header 头部 -->
    <gateway-header :bgAttr="'rgba(54, 89, 241, 1)'" />

    <div class="park-service-banner">
      <div class="img-box">
        <img :src="bannerUrl" alt="" />
      </div>
    </div>

    <div class="main-content gateway-module">
      <div class="you-position">
        <i><img src="../modules/adress.png" alt="" /></i>
        <p>
          您的位置:产业园服务>公共服务中心>常见水生疫病查询
        </p>
        <span @click="gobackpage">
          返回上级
          <img src="../../../assets/img/gateway/icon-arrow-gray.png" alt="" />
          <img
            class="img-active"
            src="../../../assets/img/gateway/icon-arrow-active.png"
            alt=""
          />
        </span>
      </div>

      <div class="sub-nav-box">
        <li class="ls-item" :class="{ 'active': selectType === 'common-diseases' }" @click="selectType = 'common-diseases'">
          常见鱼病
        </li>
        <li class="ls-item" :class="{ 'active': selectType === 'simple-diagnosis' }" @click="selectType = 'simple-diagnosis'">
          简易诊断
        </li>
        <li class="ls-item" :class="{ 'active': selectType === 'disease-forecast' }" @click="selectType = 'disease-forecast'">
          病害预报
        </li>
      </div>


      <div class="module-content">
        <template v-if="selectType === 'common-diseases'">
          <CommonDiseases></CommonDiseases>
        </template>

        <template v-if="selectType === 'simple-diagnosis'">
          <SimpleDiagnosis></SimpleDiagnosis>
        </template>
        
        <template v-if="selectType === 'disease-forecast'">
          <DiseaseForecast></DiseaseForecast>
        </template>
      </div>
    </div>

    <gateway-footer style="background: #031236; color: #fff" />
    <ToTopperComponent />
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import GatewayHeader from '../../../components/gateway-header.vue'
import GatewayFooter from '../../../components/gateway-footer.vue'
import ToTopperComponent from '../../../components/to-topper-component.vue'
import CommonDiseases from './common-diseases.vue'
import SimpleDiagnosis from './simple-diagnosis.vue'
import DiseaseForecast from './disease-forecast.vue'

export default {
  name: 'diseases',
  data() {
    return {
      bannerUrl: '',
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000, //1秒切换一次
        },
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      selectType: 'common-diseases',
      
    }
  },
  computed: {},
  methods: {
    gobackpage() {
      this.$router.push(`/parkService?type=2`)
    },
  },
  components: {
    GatewayHeader,
    GatewayFooter,
    ToTopperComponent,
    swiper,
    swiperSlide,
    CommonDiseases,
    SimpleDiagnosis,
    DiseaseForecast,
  },
  created() {
    this.$axios('/zhanjiang-portal/frontIndustrial/getBanner').then(
      (r) => (this.bannerUrl = r.data[0].url || '')
    )
  },
}
</script>
<style lang="less" scoped>
@import './diseases.less';
</style>
